import React from 'react'
import PropTypes from 'prop-types'

import ColorBar from '../../atoms/ColorBar'
import GridContainer from '../../atoms/FoundationGrid/GridContainer'
import Grid from '../../atoms/FoundationGrid/Grid'
import Cell from '../../atoms/FoundationGrid/Cell'
import Table from '../../molecules/Table'

import './style.scss'

const FundDetailPortfolioTab = ({ fundDetailPortfolioTabInfo, holdingsType, children, gridContainerExtraClass, gridExtraClasses }) => {
  const necessaryElements = {
    ColorBar
  }

  return (
    <GridContainer extraClasses={`fil-fund-detail__tab-portfolio ${gridContainerExtraClass}`}>
      <Grid extraClasses={`fil-fund-detail__tab-portfolio-grid ${gridExtraClasses}`}>
        {children ? (
          <React.Fragment>{children}</React.Fragment>
        ) : (
          fundDetailPortfolioTabInfo.map((portfolioItem, index) => {
            const { title, date, key, tableData, tableDisclaimer, needInitSort } = portfolioItem
            return (
              <Cell
                extraClasses={`small-12 ${holdingsType === 'type3' ? '' : 'large-6'} cell-spacing fil-fund-detail__${
                  index % 2 === 0 ? 'first' : 'second'
                }-table-column`}
                key={key}
              >
                <Table
                  title={
                    <React.Fragment>
                      <span className="text-heading-s">{title}</span>
                      <span className="text-body-m"> ({date.replace(/\//g, '-')})</span>
                    </React.Fragment>
                  }
                  tableId={`fil-fund-detail__portfolio-table-${key}`}
                  tableData={tableData}
                  tableDisclaimer={tableDisclaimer}
                  necessaryElements={necessaryElements}
                  needInitSort={needInitSort}
                  isSimpleTable
                  textSize="small"
                  size="small"
                />
              </Cell>
            )
          })
        )}
      </Grid>
    </GridContainer>
  )
}

FundDetailPortfolioTab.propTypes = {
  fundDetailPortfolioTabInfo: PropTypes.array,
  holdingsType: PropTypes.string,
  children: PropTypes.any,
  gridContainerExtraClass: PropTypes.string,
  gridExtraClasses: PropTypes.string
}

FundDetailPortfolioTab.defaultProps = {
  fundDetailPortfolioTabInfo: [],
  holdingsType: '',
  gridContainerExtraClass: '',
  gridExtraClasses: '',
  children: null
}

export default FundDetailPortfolioTab
